"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var format_string_by_pattern_1 = __importDefault(require("format-string-by-pattern"));
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var react_final_form_1 = require("react-final-form");
var InputText_1 = __importDefault(require("../../InputText"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var InputField = function (_a) {
    var field = _a.field, _b = _a.mask, mask = _b === void 0 ? '' : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(react_final_form_1.Field, { name: field, parse: mask ? (0, format_string_by_pattern_1.default)(mask) : function (v) { return v; } }, function (_a) {
        var input = _a.input, meta = _a.meta;
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper },
            react_1.default.createElement(InputText_1.default, __assign({ labelText: t("".concat((field === null || field === void 0 ? void 0 : field.name) || 'customer.' + field, ".title")), id: field, placeholder: t("".concat((field === null || field === void 0 ? void 0 : field.name) || 'customer.' + field, ".placeholder")), type: field, helpertext: meta.error && meta.touched
                    ? { status: 'error', text: meta.error }
                    : undefined }, input))));
    }));
};
exports.default = InputField;
